import ExploreFundsUseCase from "@domains/features/Markets/MutualFunds/useCases/exploreFunds";
import MutualFundHousesUseCase from "@domains/features/Markets/MutualFunds/useCases/MutualFundsHouseUseCase";
import MutualFundsSchemesUseCase from "@domains/features/Markets/MutualFunds/useCases/MutualFundsSchemesUseCase";
import MutualFundFiltersUseCase from "@domains/features/Markets/MutualFunds/useCases/MutualFundFiltersUseCase";
import MutualFundsSchemesCategoryUseCase from "@domains/features/Markets/MutualFunds/useCases/MutualFundsSchemesCategory";
import SchemeCategoryUseCase from "@domains/features/Markets/MutualFunds/useCases/MutualFundsSchemeCategoryUseCase";
import MfPurchaseSipCtaUseCase from "@domains/features/Markets/MutualFunds/useCases/iMfPurcaseSipCtaUseCase";
export default (function (repositories) {
    return {
        mutualFunds: {
            exploreFunds: new ExploreFundsUseCase(repositories.mutualFunds),
            mutualFundsSchemes: new MutualFundsSchemesUseCase(repositories.mutualFunds),
            mutualFundsHouse: new MutualFundHousesUseCase(repositories.mutualFunds),
            mutualFundFilters: new MutualFundFiltersUseCase(repositories.mutualFunds),
            mutualFundsCategory: new MutualFundsSchemesCategoryUseCase(repositories.mutualFunds),
            schemeCategory: new SchemeCategoryUseCase(repositories.mutualFunds),
            mfPurchaseSipCtaUseCase: new MfPurchaseSipCtaUseCase(repositories.mutualFunds),
        },
    };
});
